// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
     SearchInput.prototype.onCloseAutocomplete = function(event, autocompleteUi) {
       var self = this;
       setTimeout(function(){
         if (self.instantSearchResult && self.instantSearchResult.$instantSearchResult && self.instantSearchResult.$wrapper) {
           /**
			 * Test Mode - Turn on when need check elements of Auto Complete
			 * Prevent closing Auto complete when opening Inspect Element
			 */
           var isSearchContainerOpened = jQ(".search-overlay--desktop.overlay-visible").length > 0
           var searchbarHasValue = event.target.value.trim().length > 0
           var searchShouldBeOpened = searchbarHasValue && isSearchContainerOpened
           if (Settings.getSettingValue('search.suggestionMode') == 'test' || Utils.InstantSearch.isFullWidthMobile() || searchShouldBeOpened) {
             self.instantSearchResult.$instantSearchResult.show();
           } else {
             self.instantSearchResult.$instantSearchResult.siblings().hide();
           }
           if (!Utils.isiOS() && !searchShouldBeOpened) {
             self.instantSearchResult.$wrapper.removeClass(Class.searchSuggestionOpen);
           }

         }
       } , 200)
	}

    
})();